import { render, staticRenderFns } from "./ChartWork.vue?vue&type=template&id=a5139120&scoped=true"
import script from "./ChartWork.vue?vue&type=script&lang=ts"
export * from "./ChartWork.vue?vue&type=script&lang=ts"
import style0 from "./ChartWork.vue?vue&type=style&index=0&id=a5139120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5139120",
  null
  
)

export default component.exports